import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for `/hosts/*` — same fix as `approvals.tsx`/`bookings.tsx`. */
export const Route = createFileRoute('/hosts')({
  component: HostsLayout,
});

function HostsLayout() {
  return <Outlet />;
}
